import { Declaration } from 'store/declarations/declaration';
import { getMirrorDucr } from '../getMirrorDucr';
import { getMirrorPendingDucrLabel } from '../getMirrorPendingDucrLabel';

// The DUCR of a mirrored declaration, or the label standing in for it until the BE generates one.
// The source H1 has no mirror details, so it has neither.
export const getMirroredRowDucrText = (declaration: Declaration, messageType: string) =>
    getMirrorDucr(declaration.mirrorDetails) ?? getMirrorPendingDucrLabel(declaration.mirrorDetails, messageType);
